import React from 'react';
import { observable, decorate } from "mobx";
import CardContent from '@material-ui/core/CardContent';
import { I18n } from 'aws-amplify';
import ActionModel from "../../../../../models/ActionModel/ActionModel";
import NewActionHeader from '../../NewAction/NewActionHeader/NewActionHeader';
import UsernameInput from '../../NewAction/inputs/UsernameInput/UsernameInput';

class FacebookAction extends ActionModel {
	static metadata = {
		id: "facebook",
		name: "Facebook",
		icon: "https://l.fast.cm/content/icons/facebook.png",
		categories: {
			// social: true
		}
	};

	constructor(dat) {
		super();

		//this.propNames = ["Title", "Image", "Subtitle", "ButtonText", "destId"];
		this.propNames.push("destId");

		this.setFromObject(dat);
	}

	Title = "Facebook";
	Link = "https://www.facebook.com/";
	ButtonText = "GO";
	isValid = false;
	destId = '';

	getConfigCardBody(cardModel, handleOnChangeIcon) {
		return (
			<CardContent>
				<NewActionHeader
					onChangeIcon={handleOnChangeIcon}
					actionModel={this} />

				<UsernameInput
					baseUrl="https://www.facebook.com/"
					placeHolderText={I18n.get("_username")}
					cardModel={cardModel}
					actionModel={this} />
			</CardContent>
		)
	}

	getRules() {
		return {
			destId: {
				presence: { allowEmpty: false }
			},
			...super.getRules()
		}
	}
}

decorate(FacebookAction, {
	Title: observable,
	Link: observable,
	isValid: observable,
	ButtonText: observable,
	destId: observable,
})

export default FacebookAction
